export default __webpack_public_path__ + "static/media/youtube-img.4723b839.jpg";